import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';

export interface DemoBadgeProps extends HTMLAttributes<HTMLSpanElement> {
    compact?: boolean;
}

const StyledDemoBadge = styled.span<{ $compact: boolean }>`
    display: inline-flex;
    align-items: center;
    width: fit-content;
    padding: ${(props) => (props.$compact ? '1px 3px' : '2px 7px')};
    border-radius: ${(props) => (props.$compact ? '3px' : '4px')};
    background: #263238;
    color: #fff;
    font-size: ${(props) => (props.$compact ? '8px' : '10px')};
    font-weight: 700;
    line-height: ${(props) => (props.$compact ? '11px' : '16px')};
    letter-spacing: 0.25px;
    white-space: nowrap;

    ${(props) =>
        props.$compact &&
        `
            position: absolute;
            top: 2px;
            left: 2px;
        `}
`;

export const DemoBadge: FC<DemoBadgeProps> = ({ compact = false, children, ...rest }) => (
    <StyledDemoBadge {...rest} $compact={compact}>
        {children}
    </StyledDemoBadge>
);
